module.exports = __webpack_public_path__ + "img/1970East-023_WEB-min.73b5ac36.jpg";